module.exports = __webpack_public_path__ + "img/logo_et.9a201031.png";